import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Accordion, Button, Form, Container, Row, Col } from 'react-bootstrap';

const EditarHorarios = () => {
  const [localId, setLocalId] = useState(1); // Sucursal seleccionada
  const [horarios, setHorarios] = useState([]);
  const [error, setError] = useState(null);
  const diasSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

  useEffect(() => {
    if (localId) {
      fetchHorarios();
    }
  }, [localId]);

  const fetchHorarios = async () => {
    try {
      const response = await axios.get(`https://pedir-prueba.p89nps.easypanel.host/horarios/${localId}`);
      setHorarios(response.data);
    } catch (error) {
      setError('Error al obtener horarios.');
      console.error('Error al obtener horarios:', error);
    }
  };

  const handleChange = (index, field, value) => {
    const nuevosHorarios = [...horarios];
    nuevosHorarios[index][field] = value;
    setHorarios(nuevosHorarios);
  };

  const handleSaveDay = async (dia) => {
    try {
      await axios.put(`https://pedir-prueba.p89nps.easypanel.host/horarios/${localId}/${dia.dia_semana}`, {
        hora_apertura: dia.hora_apertura,
        hora_cierre: dia.hora_cierre,
        cerrado: dia.cerrado,
      });
      alert(`Horario del día ${diasSemana[dia.dia_semana]} actualizado correctamente.`);
    } catch (error) {
      console.error('Error al actualizar horario:', error);
      alert(`Error al actualizar el horario del día ${diasSemana[dia.dia_semana]}.`);
    }
  };

  return (
    <Container>
      <h2 className="my-4">Editar Horarios</h2>

      {/* Dropdown para seleccionar la sucursal */}
      <Row className="mb-4">
        <Col>
          <Form.Label>Selecciona una sucursal: </Form.Label>
          <Form.Control as="select" value={localId} onChange={(e) => setLocalId(e.target.value)}>
            <option value={1}>Sucursal 1</option>
            <option value={2}>Sucursal 2</option>
            {/* Agregar más opciones dinámicamente si es necesario */}
          </Form.Control>
        </Col>
      </Row>

      {/* Acordeones por día */}
      <Accordion defaultActiveKey="0">
        {horarios.length > 0 ? (
          horarios.map((dia, index) => (
            <Accordion.Item key={index} eventKey={index.toString()}>
              <Accordion.Header>
                <strong>{diasSemana[dia.dia_semana]}</strong>
              </Accordion.Header>
              <Accordion.Body>
                <Row className="mb-3">
                  <Col xs={12} md={6}>
                    <Form.Group controlId={`hora_apertura_${index}`}>
                      <Form.Label>Hora Apertura</Form.Label>
                      <Form.Control
                        type="time"
                        value={dia.hora_apertura}
                        onChange={(e) => handleChange(index, 'hora_apertura', e.target.value)}
                        disabled={dia.cerrado === 1}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Group controlId={`hora_cierre_${index}`}>
                      <Form.Label>Hora Cierre</Form.Label>
                      <Form.Control
                        type="time"
                        value={dia.hora_cierre}
                        onChange={(e) => handleChange(index, 'hora_cierre', e.target.value)}
                        disabled={dia.cerrado === 1}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Form.Group controlId={`cerrado_${index}`} className="mb-3">
                  <Form.Check
                    type="checkbox"
                    label="Cerrado"
                    checked={dia.cerrado === 1}
                    onChange={() => handleChange(index, 'cerrado', dia.cerrado === 1 ? 0 : 1)}
                  />
                </Form.Group>

                {/* Botón para guardar cambios del día */}
                <Button variant="primary" onClick={() => handleSaveDay(dia)}>Aplicar cambios</Button>
              </Accordion.Body>
            </Accordion.Item>
          ))
        ) : (
          <p>No hay horarios disponibles para esta sucursal.</p>
        )}
      </Accordion>

      {/* Mostrar error si existe */}
      {error && <p style={{ color: 'red' }}>{error}</p>}
    </Container>
  );
};

export default EditarHorarios;
